import { API_CONFIG } from './restServiceConfig'

export const ENTITIES_APIS: Record<string, API_CONFIG> = {
  Me: {
    url: '/api/users/me/',
    options: ['GET',],
    headers: {}
  },
  Users: {
    url: '/api/users/',
    options: ['GET', 'POST', 'PUT', 'DELETE'],
    headers: {}
  },
  AuthPasswordChange: { url: '/api/auth/password/change/', options: ['POST'], headers: {} },
  AuthPasswordReset: { url: '/api/auth/password/reset/', options: ['POST'], headers: {} },
  AuthPasswordResetConfirm: { url: '/api/auth/password/reset/confirm/', options: ['POST'], headers: {} },
  TrainingAssetRequests: {
    url: '/api/training-asset-requests/',
    options: ['GET', 'POST', 'PUT', 'PATCH', 'DELETE'],
    headers: {}
  },
  Courses: {
    url: '/api/university/courses/',
    options: ['GET', 'POST', 'PUT', 'PATCH', 'DELETE'],
    headers: {}
  },
  Universities: {
    url: '/api/university/',
    options: ['GET', 'POST', 'PUT', 'PATCH', 'DELETE'],
    headers: {}
  },
  CrossLogin: {
    url: '/api/users/single-sign-in/',
    options: ['POST'],
    headers: {}
  }
}

export const CATALOGS_APIS: Record<string, API_CONFIG> = {
  UniversitiesCatalogsUniversity: {
    url: '/api/university/catalogs/universities/',
    options: ['GET'],
    headers: {}
  },
  UniversitiesCatalogsCourses: {
    url: '/api/university/catalogs/courses/',
    options: ['GET'],
    headers: {}
  },
  TrainingAssetRequestsStatuses: {
    url: '/api/training-asset-requests/statuses/',
    options: ['GET'],
    headers: {}
  }
}

type API_NAME = keyof typeof ENTITIES_APIS | keyof typeof CATALOGS_APIS

export const APIS: Record<API_NAME, API_CONFIG> = {
  ...ENTITIES_APIS,
  ...CATALOGS_APIS
}
